import React, { useEffect, useState } from 'react';
import { TrendingUpIcon, UsersIcon, AwardIcon, CalendarIcon } from 'lucide-react';
export function YtJuevesAuthorBio() {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/aZ41yWsvw3Ys3qFztBknzU/Generated_Image_October_06%2C_2025_-_3_36PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wN1c99C5pV1ppV8Li7kJbG/WhatsApp_Image_2025-11-10_at_21.03.00.jpg'];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const stats = [{
    icon: CalendarIcon,
    value: '10+',
    label: 'Años de Experiencia'
  }, {
    icon: TrendingUpIcon,
    value: 'Proyectos',
    label: 'Digitales'
  }, {
    icon: UsersIcon,
    value: 'Miles',
    label: 'de Estudiantes'
  }, {
    icon: AwardIcon,
    value: 'Programas',
    label: 'Educativos'
  }];
  return <section data-id="element-701">
      <div className="max-w-6xl mx-auto" data-id="element-702">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-8 md:mb-12 text-center leading-tight" data-id="element-703">
          Conoce a Tu Mentor
        </h2>

        <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 md:p-8 lg:p-12 shadow-2xl" data-id="element-704">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-8" data-id="element-705">
            <div className="flex justify-center" data-id="element-706">
              <div className="w-full max-w-sm" data-id="element-707">
                <div className="aspect-square w-full overflow-hidden rounded-xl shadow-lg" data-id="element-708">
                  <img src={images[currentImageIndex]} alt="Gabriel Beltrán" className="w-full h-full object-cover transition-opacity duration-500" data-id="element-709" />
                </div>
              </div>
            </div>

            <div className="text-center md:text-left" data-id="element-710">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-711">
                Gabriel Beltrán
              </h3>
              <p className="text-red-400 font-semibold mb-6 text-lg" data-id="element-712">
                Emprendedor Digital & Mentor
              </p>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6" data-id="element-713">
                Más de 10 años de experiencia en proyectos digitales, educación
                online y consultoría en negocios digitales. Ha trabajado con
                miles de estudiantes en diferentes programas educativos.
              </p>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-714">
                Basado en Miami, FL • Speaker Internacional • Mentor de
                Emprendedores
              </p>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 pt-8 border-t border-gray-700 mb-8" data-id="element-715">
            {stats.map((stat, index) => {
            const Icon = stat.icon;
            return <div key={index} className="text-center" data-id="element-716">
                  <div className="flex justify-center mb-3" data-id="element-717">
                    <div className="bg-red-600 bg-opacity-20 rounded-full p-3" data-id="element-718">
                      <Icon className="h-6 w-6 text-red-400" data-id="element-719" />
                    </div>
                  </div>
                  <div className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-720">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-gray-400" data-id="element-721">
                    {stat.label}
                  </div>
                </div>;
          })}
          </div>

          {/* Featured In / Trust Badges */}
          <div className="pt-6 border-t border-gray-700" data-id="element-722">
            <p className="text-center text-sm text-gray-400 mb-4" data-id="element-723">
              Gabriel ha aparecido y/o sido mencionado en medios de negocios y
              emprendimiento como:
            </p>
            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-4" data-id="element-724">
              <div className="text-gray-500 font-bold text-lg" data-id="element-725">Forbes</div>
              <div className="text-gray-500 font-bold text-lg" data-id="element-726">
                Entrepreneur
              </div>
              <div className="text-gray-500 font-bold text-lg" data-id="element-727">
                Inc. Magazine
              </div>
              <div className="text-gray-500 font-bold text-lg" data-id="element-728">
                Business Insider
              </div>
            </div>
            <p className="text-xs text-gray-500 text-center" data-id="element-729">
              (Las menciones en medios se basan en apariciones y artículos
              publicados sobre su actividad profesional.)
            </p>
          </div>
        </div>
      </div>
    </section>;
}